module.exports = __webpack_public_path__ + "static/media/n22.04f5f2de.jpg";